import React, { useState } from "react";
import { _post } from "../services/service_api";
import { ADD_SLOTS, API_BASE_URL } from "../services/end_points";
import { Alert, Button, Col, Form, Input, Row, Tag, Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
const AddSlots = ({ data }) => {
  const [alert, setAlert] = useState(null);

  const [datesData, setDatesData] = useState({
    formDate: "",
    toDate: "",
    holiday: [],
    intervalTime: "",
    doctorId: data,
    fromTime: "",
    toTime: "",
  });
  const [fromDateInput, setFromDateInput] = useState(false);
  const handleFocusFromDate = () => setFromDateInput(true);
  const handleBlurFromDate = (e) => {
    if (!e.target.value) setFromDateInput(false);
  };
  const [toDateInput, setToDateInput] = useState(false);
  const handleFocusToDate = () => setToDateInput(true);
  const handleBlurToDate = (e) => {
    if (!e.target.value) setToDateInput(false);
  };
  const [holidayInput, setHolidayInput] = useState(false);
  const handleFocusHoliday = () => setHolidayInput(true);
  const handleBlurHoliday = (e) => {
    if (!e.target.value) setHolidayInput(false);
  };
  const [fromTimeInput, setFromTimeInput] = useState(false);
  const handleFocusFromTime = () => setFromTimeInput(true);
  const handleBlurFromTime = (e) => {
    if (!e.target.value) setFromTimeInput(false);
  };
  const [toTimeInput, setToTimeInput] = useState(false);
  const handleFocusToTime = () => setToTimeInput(true);
  const handleBlurToTime = (e) => {
    if (!e.target.value) setToTimeInput(false);
  };
  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === "holiday" && value) {
      const formattedDate = moment(value).format("ddd DD MMM YYYY");
      //console.log("dates fromat",formattedDate);
      setDatesData((prevData) => {
        const updatedHolidays = [
          ...new Set([...prevData.holiday, formattedDate]),
        ];
        return {
          ...prevData,
          holiday: updatedHolidays,
        };
      });
    } else if (name === "formDate" || name === "toDate") {
      setDatesData((prevData) => ({
        ...prevData,
        [name]: moment(value).format("ddd DD MMM YYYY"),
      }));
    } else {
      setDatesData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleDateRemove = (date) => {
    setDatesData((prevData) => ({
      ...prevData,
      holiday: prevData.holiday.filter((d) => d !== date),
    }));
  };

  const handleSubmitTime = async (e) => {
    e.preventDefault();

    // Convert the fromTime and toTime to 12-hour format with AM/PM
    const formattedFromTime = moment(datesData.fromTime, "HH:mm").format(
      "hh:mm A"
    );
    const formattedToTime = moment(datesData.toTime, "HH:mm").format("hh:mm A");

    const postData = {
      fromDate: datesData.formDate,
      toDate: datesData.toDate,
      holiday: datesData.holiday,
      doctorId: parseInt(datesData.doctorId, 10),
      fromTime: formattedFromTime, // Use formatted time here
      toTime: formattedToTime, // Use formatted time here
      interval: datesData.intervalTime.toString(),
    };

    try {
      const result = await _post(`${API_BASE_URL}${ADD_SLOTS}`, postData);
      if (result.status === 201) {
        setAlert(true);
        setDatesData({
          formDate: "",
          toDate: "",
          holiday: [],
          intervalTime: "",
          doctorId: "",
          fromTime: "",
          toTime: "",
        });
      }
    } catch (err) {
      setAlert(false);
      console.error("Error details:", err);
      if (err.response) {
        console.error("Server responded with status:", err.response.status);
        console.error("Response data:", err.response.data);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }
    }
  };

  const handleReset = () => {
    setDatesData({
      formDate: "",
      toDate: "",
      holiday: [],
      intervalTime: "",
      doctorId: data,
      fromTime: "",
      toTime: "",
    });
  };
  return (
    <>
      <Form layout="vertical">
        <div>
          {alert && (
            <div marginBottom="20px">
              <Alert
                type="success"
                style={{
                  backgroundColor: "#009f70e6",
                  color: "white",
                  width: "455px",
                  marginBottom: "20px",
                }}
                message={"Slots Created!"}
              />
            </div>
          )}
          {alert === false && (
            <div marginBottom="20px">
              <Alert
                type="fail"
                style={{
                  backgroundColor: "red",
                  color: "white",
                  width: "455px",
                  marginBottom: "20px",
                }}
                message={"Not Slots Created!"}
              />
            </div>
          )}
        </div>
        <Row style={{ gap: "8px" }}>
          <Col xl={11} lg={10} sm={24} md={12}>
            <div>
              <Form.Item label="From Date" labelAlign="top" required>
                <Input
                  type={fromDateInput ? "date" : "text"}
                  name="formDate"
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  onChange={handleDateChange}
                  onFocus={handleFocusFromDate}
                  onBlur={handleBlurFromDate}
                />
              </Form.Item>
            </div>
          </Col>

          <Col xl={11} lg={10} sm={24} md={12}>
            <Form.Item label="To Date" labelAlign="top" required>
              <Input
                type={toDateInput ? "date" : "text"}
                name="toDate"
                style={{
                  width: "100%",
                  height: "40px",
                }}
                onChange={handleDateChange}
                onFocus={handleFocusToDate}
                onBlur={handleBlurToDate}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ gap: "8px", marginTop: "1rem" }}>
          <Col xl={11} lg={10} sm={24} md={12}>
            <Form.Item label="Holiday" labelAlign="top" required>
              <Input
                style={{ marginTop: "2px", width: "100%", height: "40px" }}
                type={holidayInput ? "date" : "text"}
                name="holiday"
                onChange={handleDateChange}
                onFocus={handleFocusHoliday}
                onBlur={handleBlurHoliday}
              />
              {datesData.holiday.map((date, index) => (
                <Tag
                  key={index}
                  color="error" // You can use predefined colors like 'error', 'success', or custom color
                  closable
                  onClose={() => handleDateRemove(date)} // Handles tag close
                  style={{
                    margin: "4px",
                    width: "136px",
                    fontSize: "small",
                    backgroundColor: "#ff3737",
                    color: "white",
                  }}
                  closeIcon={<CloseCircleOutlined style={{ color: "white" }} />}
                >
                  {date}
                </Tag>
              ))}
            </Form.Item>
          </Col>

          <Col xl={11} lg={10} sm={24} md={12}>
            <Form.Item label="Duration [MM]" labelAlign="top" required>
              <Input
                style={{
                  position: "relative",
                  width: "100%",
                  height: "40px",
                }}
                required
                name="intervalTime"
                value={datesData.intervalTime}
                onChange={handleDateChange}
                variant="outlined"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ gap: "8px", marginTop: "1rem" }}>
          <Col xl={11} lg={10} sm={24} md={12}>
            <Form.Item label="From Time" labelAlign="top" required>
              <Input
                style={{
                  width: "100%",
                  height: "40px",
                }}
                required
                name="fromTime"
                type={fromTimeInput ? "time" : "text"}
                value={datesData.fromTime}
                onChange={handleDateChange}
                onFocus={handleFocusFromTime}
                onBlur={handleBlurFromTime}
                variant="outlined"
              />
            </Form.Item>
          </Col>

          <Col xl={11} lg={10} sm={24} md={12}>
            <Form.Item label="To Time" labelAlign="top" required>
              <Input
                style={{
                  width: "100%",
                  height: "40px",
                }}
                required
                name="toTime"
                type={toTimeInput ? "time" : "text"}
                value={datesData.toTime}
                onChange={handleDateChange}
                onFocus={handleFocusToTime}
                onBlur={handleBlurToTime}
                variant="outlined"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ gap: "8px", marginTop: "1rem" }}>
          <Col xl={24} lg={24} sm={24} md={24}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                type="button"
                onClick={handleReset}
                style={{
                  color: "black",
                  border: "solid #1236fa",
                  width: "70px",
                  borderRadius: "12px",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                onClick={handleSubmitTime}
                style={{
                  color: "white",
                  background: "#1236fa",
                  width: "70px",
                  borderRadius: "12px",
                }}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default AddSlots;
